var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',{attrs:{"messages":_vm.messages,"hide-details":_vm.hideDetails}},[_c('editor-content',{staticClass:"w-full",attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }